import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGem } from '@fortawesome/free-solid-svg-icons'
import { resourceColor } from '../../config/resourceVisuals'
import './prototype.css'

// ─── Inventory cards ─────────────────────────────────────────────────────────
// The playing-card tiles of the Hive's inventory shelves (HiveEditor), also
// what a chest's contents come out as (ChestReveal): a picture placeholder,
// a name, and a line under it. prototype.css styles them (.pt-inv__card).

export const capitalize = (t) => t.charAt(0).toUpperCase() + t.slice(1)
// A lot is named for its terrain; what it yields keeps the resource's name.
const LOT_TERRAIN = {
    timber: 'Forest', metal: 'Mountain', coal: 'Coalfield', water: 'Spring',
    oil: 'Oilfield', silicon: 'Quartz Ridge', sand: 'Dunes',
}
export const lotName = (type) => LOT_TERRAIN[type] ?? capitalize(type)
export const initials = (name) => name.split(/\s+/).map(w => w[0]).join('').slice(0, 2).toUpperCase()

// The picture placeholder for each kind of thing. A lot is a hex in its
// resource's colour, as it sits on the Hive; a resource is a solid swatch.
export const LotArt = ({ type }) => (
    <span className="pt-inv__art pt-inv__art--resource">
        <span className="pt-inv__res-hex" style={{ background: resourceColor(type) }} />
    </span>
)
export const StructureArt = ({ name }) => <span className="pt-inv__art pt-inv__art--structure">{initials(name)}</span>
export const ResourceArt = ({ type }) => <span className="pt-inv__art" style={{ background: resourceColor(type) }} />
export const GemArt = () => (
    <span className="pt-inv__art pt-inv__art--resource">
        <FontAwesomeIcon icon={faGem} className="pt-inv__gem" />
    </span>
)

// A card. With `onClick` it's a button; `className` adds states
// (pt-inv__card--on, --placed) or a context's sizing; `badge` sits in its
// top-right corner; `meter` (0–1) is a thin bar along its bottom.
export default function InvCard({ art, name, sub, badge = null, meter = null, className = '', onClick, style }) {
    const cls = `pt-inv__card${meter != null ? ' pt-inv__card--metered' : ''}${className ? ` ${className}` : ''}`
    const body = (
        <>
            {art}
            <span className="pt-inv__name">{name}</span>
            {sub != null && <span className="pt-inv__sub">{sub}</span>}
            {badge}
            {meter != null && (
                <span className={meter >= 1 ? 'pt-inv__meter pt-inv__meter--full' : 'pt-inv__meter'}>
                    <span className="pt-inv__meter-fill" style={{ width: `${Math.round(meter * 100)}%` }} />
                </span>
            )}
        </>
    )
    return onClick
        ? <button className={cls} style={style} onClick={onClick}>{body}</button>
        : <div className={cls} style={style}>{body}</div>
}
